import { JtCrud } from 'jtech-webcomps'
export const state = JtCrud.state
